import React from "react"
import { Modal, Button } from "antd"
import { CheckCircleOutlined } from "@ant-design/icons"

const SuccessPopup = ({ visible, onClose }) => (
  <Modal
    visible={visible}
    footer={null}
    closable={false}
    centered
    bodyStyle={{ textAlign: "center" }}
  >
    <div className="default-font">
      <CheckCircleOutlined style={{ fontSize: 48, color: "green" }} />
      <div className="my-3">
        <h3>Goal Set Successfully!</h3>
      </div>
      <p>Your indicator goal has been successfully saved.</p>
      <p>
        Keep tracking your progress to ensure you are meeting key benchmarks.
      </p>
      <Button className="notification-button" danger onClick={onClose}>
        Done
      </Button>
    </div>
  </Modal>
)

export default SuccessPopup
